import axios from 'axios';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { Announcement, Button, CardAction, Loader, Navbar, Sidebar, Spacer, TransactionHash } from '../../components';
import URL from "../../config/api.json";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function MultipleWallet() {
  const [closeSide, setCloseSide] = useState(false)
  const [provider, setProvider] = useState([])
  const [preWalletAddress, setPreWalletAddress] = useState([])
  const [loading, setLoading] = useState(false)
  const [providerSelected, setProviderSelected] = useState('');
  const [formType, setFormType] = useState('Pancakeswap V2')
  const [transType, setTransType] = useState('buy')
  const [ann, setAnn] = useState(true)

  const [bAct,setBAct] = useState('')
  const [sAct,setSAct] = useState('')

  // RESULT
  const [receipt, setReceipt] = useState([])
  // USEFORM
  const [inputProvider, setInputProvider] = useState('')
  const [inputToken, setInputToken] = useState('')
  const [inputTokenOut, setInputTokenOut] = useState('0.008')
  const [nonce, setNonce] = useState('')
  const [inputBnb, setInputBnb] = useState('0.008')
  const [countBuy, setCountBuy] = useState('')
  const [countSell, setCountSell] = useState('')

  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  const getProvider = async () => {
    const result = await axios.get(`${URL.API_URL}providers`)
    if (result.data.data) {
      setProvider(result.data.data)
    } else {
      setProvider([
        {
          id: 1,
          name: "Pancakeswap V2"
        },
        {
          id: 2,
          name: "Uniswap V2"
        }
      ])
    }
  }
  const changeTransType = async (type) => {
    if(type === 'buy'){
      setBAct('active')
      setSAct('')
    }
    if(type === 'sell'){
      setSAct('active')
      setBAct('')
    }
    const res = await axios.get(`${URL.API_URL}trax/init`);
    setNonce(res.data.data)
    setTransType(type)
  }


  const changeHandler = async (event) => {
    const val = event.target.value;
    setInputProvider(val)
    setFormType(val)
    setProviderSelected(val)
  }
  const updatePreloaded = async () => {
    if (providerSelected) {
      setLoading(true)
      const result = await axios.get(`${URL.API_URL}trax/balance?provider=${providerSelected}`)
      setPreWalletAddress(result.data.data)
      setLoading(false)
    }
  }




  const executeTraxBuy = () => {
    setLoading(true)
    const FormData = require('form-data');
    const data = new FormData();
    data.append('provider', inputProvider);
    data.append('token', inputToken);
    data.append('bnbin', inputBnb);
    data.append('count', countBuy);
    data.append('nonce', nonce);

    const config = {
      method: 'post',
      url: `${URL.API_URL}trax/xbuy`,
      data: data
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);
        setReceipt(response.data.data);
        setLoading(false)
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false)
      });
  }

  const executeTraxSell = () => {
    setLoading(true)
    const FormData = require('form-data');
    const data = new FormData();
    data.append('provider', inputProvider);
    data.append('token', inputToken);
    data.append('token_out', inputTokenOut);
    data.append('nonce', nonce);
    data.append('count', countSell);

    const config = {
      method: 'post',
      url: `${URL.API_URL}trax/xsell`,
      data: data
    };

    axios(config)
      .then(function (response) {
        setReceipt(response.data.data);
        setLoading(false)
        toast.success("Transactions Success!")
      })
      .catch(function (error) {
        toast.error(error)
        setLoading(false)
      });
  }

  const getMaxBallance = async () => {
    if(inputProvider && inputToken){
      const res = await axios.get(`${URL.API_URL}trax/token?provider=${inputProvider}&token=${inputToken}`);
      setInputTokenOut(res.data.data.balance_readable)
    }else{
      toast.warning('Please select provider and fill token!')
    }
  }


  useEffect(() => {
    getProvider()
  }, [])
  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            {
              ann && <Announcement
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                onClick={() => setAnn(false)}
                varian="dark"
              />
            }
            <CardAction />
            <div className="row">
              <div className="col-xl-7">
                <Spacer h={20} />
                <div className="cardContainer">
                  <ul>
                    <li>The apps works only in BSC Testnet [PancakeswapV2] and Rinkeby [Uniswap V2].</li>
                    <li>There are 50 default wallets with pre-loaded ETH and BNB is shown in the table. Click update to see updated balance.</li>
                    <li>Test token for Pancakeswap V2: 0x13d6e9d980f3603d9ac4863e98f7429c64da415f</li>
                    <li>Test token for Uniswap V2: 0x9A87BDe78AB6C60e060F8d342F11929962484310</li>
                    <li>You can test with your token as long as it has liquidity and deployed in BSC Testnet/Rinkeby</li>
                    <li>The apps able to execute multiple buy up to 5 transaction/second for multiple wallet</li>
                    <li>Amount to buy is limited to 0.008 BNB/ETH and maximum wallet to use of 50 wallets</li>
                  </ul>
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="mb-3 row">
                    <label htmlFor="provider" className="col-sm-3 col-form-label">LP Provider</label>
                    <div className="col-sm-5">
                      <select onChange={changeHandler} className="form-select form-select-lg custom-input">
                        <option value="">Select Provider</option>
                        {
                          provider.map(prov => {
                            return <option key={prov.id} value={prov.name}>{prov.name}</option>
                          })
                        }
                      </select>
                    </div>
                    <div className="col-sm-4 mt-3 mt-sm-0">
                      <div className="btn-group myButtonGroup">
                        <button type="button" onClick={() => changeTransType('buy')} autoFocus={true} className={`btn btn-buy-sell ${bAct}`}>Buy</button>
                        <button type="button" onClick={() => changeTransType('sell')} className={`btn btn-buy-sell ${sAct}`}>Sell</button>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="token" className="col-sm-3 col-form-label">Token Adress</label>
                    <div className="col-sm-9">
                      <input onChange={(e) => setInputToken(e.target.value)} value={inputToken} placeholder="token address" type="text" className="form-control form-control-lg custom-input" />
                    </div>
                  </div>

                  {
                    transType === "sell" ? (
                      <div className="mb-3 row">
                        <label htmlFor="bnb" className="col-sm-3 col-form-label">Token Out</label>
                        <div className="col-sm-5 col-12">
                          <input onChange={(e) => setInputTokenOut(e.target.value)} value={inputTokenOut} type="text" className="form-control form-control-lg custom-input" />
                        </div>
                        <div className="col-sm-2 col-6 mt-2 mt-md-0">
                          <Button onClick={getMaxBallance} varian="orange" width="100%" label="Max" />
                        </div>
                        <div className="col-sm-2 col-6 mt-2 mt-md-0">
                          <input type="number" onChange={(e) => setCountSell(e.target.value)} value={countSell} className="form-control form-control-lg custom-input" />
                        </div>
                      </div>
                    ) : (
                      formType === 'Pancakeswap V2' ? (
                        <div className="mb-3 row">
                          <label htmlFor="bnb" className="col-sm-3 col-form-label">BNB in</label>
                          <div className="col-sm-5 col-8">
                            <input onChange={(e) => setInputBnb(e.target.value)} value={inputBnb} type="text" readOnly code="bnb" id="bnb" className="form-control form-control-lg custom-input" />
                          </div>
                          <div className="col-sm-4 col-4">
                            <input onChange={(e) => setCountBuy(e.target.value)} value={countBuy <= 50 && countBuy >= 0 ? countBuy : 50} type="number" min="1" max="50" placeholder="#wallet" className="form-control form-control-lg custom-input" />
                          </div>
                        </div>
                      ) : (
                        <div className="mb-3 row">
                          <label htmlFor="eth" className="col-sm-3 col-form-label">ETH in</label>
                          <div className="col-sm-5 col-8">
                            <input type="text" readOnly code="eth" id="eth" className="form-control form-control-lg custom-input" value="0.008" />
                          </div>
                          <div className="col-sm-4 col-4">
                            <input type="number" min="1" max="50" className="form-control form-control-lg custom-input" />
                          </div>
                        </div>
                      )
                    )
                  }
                  {
                    transType === "buy" ? (
                      <Button onClick={executeTraxBuy} varian="orange ms-auto" width={100} label="Execute" />

                    ) : (
                      <Button onClick={executeTraxSell} varian="orange ms-auto" width={100} label="Execute" />
                    )
                  }
                  {loading && <Loader />}
                </div>

                <Spacer h={20} />
                <div className="cardContainer">
                  <TransactionHash receipt={receipt} providerSelected={providerSelected} />
                </div>
              </div>
              <div className="col-xl-5">
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="cardUtil d-flex justify-content-between align-items-center mb-3">
                    <h5>Pre-loaded wallet address</h5>
                    <Button onClick={updatePreloaded} width={100} varian="myBtn purple" label="Update" />
                  </div>
                  <div className="table-responsive tableScroll scrollCustom" style={{ height: 430 }}>
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Wallet Address</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          preWalletAddress.map((item, key) => {
                            return (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{item.wallet}</td>
                                <td>{item.balance_readable.toFixed(3) + ' ' + item.curr}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                  {
                    loading && <Loader />
                  }
                </div>
              </div>
            </div>
            <Spacer h={20} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}
